import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      flexGrow: 0,
      height: '40px',
      overflow: 'unset',
    },
    spinner: {
      marginLeft: 0,
    },
    signOutContainer: {
      display: 'flex',
    },
    currentSessionDuration: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 1, 1, 0),
    },
    signInContainer: {
      display: 'flex',
    },
    tooltipContainer: {
      display: 'inline-flex',
      overflow: 'hidden',
      width: '100%',
    },
  };
};
